import React from "react";
import useSEO from "@/hooks/useSEO";
import { COMPANY } from "@/data/site";
import Hero from "@/components/sections/Hero";
import AboutSection from "@/components/sections/AboutSection";
import Strengths from "@/components/sections/Strengths";
import ServicesSection from "@/components/sections/ServicesSection";
import BrandsMarquee from "@/components/sections/BrandsMarquee";
import CasesSection from "@/components/sections/CasesSection";
import Testimonials from "@/components/sections/Testimonials";
import BlogPreview from "@/components/sections/BlogPreview";
import CTASection from "@/components/sections/CTASection";

export default function Home() {
  useSEO({
    title: "Mantenimiento Automotriz, Industrial y Naval",
    description: COMPANY.description,
    image: "https://images.unsplash.com/photo-1606577924006-27d39b132ae2",
    path: "/",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: COMPANY.fullName,
      alternateName: "GEMA",
      description: COMPANY.description,
      telephone: COMPANY.phoneRaw,
      email: COMPANY.email,
      address: { "@type": "PostalAddress", addressLocality: "Turbaco", addressRegion: "Bolívar", addressCountry: "CO" },
      areaServed: ["Automotriz", "Industrial", "Naval"],
    },
  });

  return (
    <>
      <Hero />
      <AboutSection />
      <Strengths />
      <ServicesSection />
      <BrandsMarquee />
      <CasesSection />
      <Testimonials />
      <BlogPreview />
      <CTASection />
    </>
  );
}
